import React from 'react';
import { CheckCircleIcon, StarIcon, ShieldCheckIcon, BookOpenIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { trackAddToCart, CART_URL } from '../lib/metaPixel';
export function HeroSection() {
  const bullets = ['Sistema completo de 12 semanas.', 'Menús, recetas, entrenamiento y hábitos.', 'Pensado para bajar grasa sin pasar hambre.', 'Incluye 6 bonos digitales de regalo.', 'Acceso inmediato por mail en 2 minutos y garantía de 7 días.'];
  return <section className="md:pt-44 md:pb-36 lg:pb-44 bg-gradient-to-b from-zinc-900 to-black pt-[10px] pb-[10px] space-y-[16px]" data-id="element-169">
      <div className="container mx-auto px-5 sm:px-6 md:px-8" data-id="element-170">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center max-w-7xl mx-auto" data-id="element-171">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-172">
            <div className="inline-block bg-orange-500/10 border border-orange-500/30 text-orange-500 px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-widest mb-8" data-id="element-173">
              SISTEMA DIGITAL · 12 SEMANAS
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-[5rem] font-display text-white mb-8 leading-[0.95] uppercase tracking-tight" data-id="element-174">
              Bajá <span className="text-orange-500" data-id="element-175">3 KG por mes</span> sin
              pasar hambre, sin dietas extremas y sin vivir en el gimnasio.
            </h1>

            <p className="text-xl md:text-2xl text-zinc-300 mb-6 leading-relaxed font-medium" data-id="element-176">
              Si sentís que te dejaste estar, que la panza te creció, que la
              ropa te queda más ajustada y que cada lunes volvés a prometerte
              que vas a arrancar,{' '}
              <span className="text-white font-bold border-b-2 border-orange-500" data-id="element-177">
                este plan fue creado para vos.
              </span>
            </p>

            <div className="space-y-4 mb-10 bg-zinc-900/50 p-6 rounded-2xl border border-zinc-800" data-id="element-178">
              {bullets.map((bullet, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.4,
              delay: 0.1 * index
            }} className="flex items-start gap-3" data-id="element-179">
                  <CheckCircleIcon className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-180" />
                  <span className="text-white font-medium text-lg" data-id="element-181">
                    {bullet}
                  </span>
                </motion.div>)}
            </div>

            <div className="mb-8" data-id="element-182">
              
              
              
              <div className="flex justify-center mt-3" data-id="element-183">
                <div className="inline-flex items-center gap-2 bg-orange-500/10 border border-orange-500/30 text-orange-400 px-4 py-1.5 rounded-full text-sm font-bold" data-id="element-184">
                  <BookOpenIcon className="w-4 h-4" data-id="element-185" />
                  <span className="uppercase tracking-wider" data-id="element-186">
                    <span className="text-white" data-id="element-187">199 páginas</span> de contenido
                  </span>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-4 flex-wrap bg-black/50 inline-flex px-6 py-3 rounded-full border border-zinc-800" data-id="element-188">
              <div className="flex items-center gap-1" data-id="element-189">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-190" />)}
              </div>
              <span className="text-white font-bold" data-id="element-191">
                +500 descargas verificadas
              </span>
            </div>
          </motion.div>

          {/* Right Column */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative lg:ml-10" data-id="element-192">
            <div className="relative" data-id="element-193">
              <img src="https://cdn.magicpatterns.com/uploads/65uABB7J6NcayMHpvapAT2/MOCKUP_BUNDLE_COMPLETO_1;1_2_reducido.webp" alt="Plan Anti Panza — Bundle completo: ebook, bonos digitales, app y materiales" width={1080} height={1080} loading="eager" fetchpriority="high" decoding="sync" className="w-full rounded-2xl drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-194" />
              <div className="absolute -top-6 -right-6 md:-right-12 bg-red-600 text-white w-32 h-32 md:w-40 md:h-40 rounded-full flex items-center justify-center shadow-2xl transform rotate-12 border-4 border-black" data-id="element-195">
                <div className="text-center" data-id="element-196">
                  <div className="text-4xl md:text-5xl font-display tracking-tight" data-id="element-197">
                    -50%
                  </div>
                  <div className="text-sm md:text-base font-bold uppercase tracking-widest" data-id="element-198">
                    Descuento
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}